import type {CardApiModel} from '../../../api/payment';

import {cardStore} from '../../../api/payment';
import {openUrlInANewTab} from '../../openUrlInANewTab';
import {storage} from '../../storage';
import {getEntityTypeById} from '../getEntityType';

export type Handle3dSecure = (
  url: string,
  returnUrl: string,
  resourceId: string,
) => Promise<void>;

/**
 * Web version of 3D Secure handler
 */
export const handle3dSecure: Handle3dSecure = (
  url: string,
  returnUrl: string,
) => {
  let newWindow = openUrlInANewTab(url);

  newWindow?.focus();

  return new Promise<void>(resolve => {
    // wait for 3d secure window to close after successful confirmation
    const timerId = setInterval(() => {
      try {
        if (newWindow?.location.href.startsWith(returnUrl)) {
          clearInterval(timerId);
          newWindow?.close();
          newWindow = null;
          resolve();
        }
      } catch (_error) {
        // do nothing
        // as a rule here will be an error that we can't access location of the window
        // if url is not from the same domain
      }
    }, 250);
  });
};

/**
 * Web version of 3D Secure handler in the same window (for webview)
 */
export const handle3dSecureInTheSameWindow: Handle3dSecure = (
  url: string,
  _returnUrl: string,
  resourceId: string,
) => {
  storage.setItem(SAME_WINDOW_3D_SECURE_RESOURCE_KEY, resourceId);

  window.location.href = url;

  return Promise.resolve();
};

export const getCardAfter3dSecure = async (): Promise<CardApiModel | null> => {
  const searchParams = new URLSearchParams(window.location.search);

  // if it exists, it means that Stripe redirected back after 3D Secure
  const hasStripeMarker = searchParams.has(STRIPE_MARKER);

  if (!hasStripeMarker) {
    return null;
  }

  const cardId = await storage.getItem(SAME_WINDOW_3D_SECURE_RESOURCE_KEY);

  if (getEntityTypeById(cardId) !== 'card') {
    return null;
  }

  await storage.removeItem(SAME_WINDOW_3D_SECURE_RESOURCE_KEY);

  // this method triggers sync with stripe on the backend
  const card = await cardStore.fetch({
    _id: cardId,
  });

  return card;
};

export const SAME_WINDOW_3D_SECURE_RESOURCE_KEY = '3dscr_rid';

const STRIPE_MARKER = 'setup_intent';
